import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="flex justify-center items-center my-10 ">
            <div className="w-14 h-14 border-2 border-[#545458] border-solid border-t-transparent  rounded-full animate-spin " ></div>
        </div>
    );
};

export default LoadingSpinner;
